import { Injectable, inject } from '@angular/core';
import { SiaHttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root',
})
export class SiaUtilsApi {
  private http = inject(SiaHttpService);

  private readonly apiController: string = 'utils';

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  getDateLastModified(): Promise<string> {
    return this.http.get(`${this.apiController}/import-date-last-modified`, {});
  }

  execAction(data: string) {
    return this.http.get(`${this.apiController}/` + data, {});
  }
  getTableData(schema: string, tableName: string, connectionStringName?: string | null) {
    const options = connectionStringName ? { params: { connectionStringName } } : {};
    return this.http.get(`generic-table/${schema}/${tableName}`, options);
  }
}
